import { roles } from 'common-src/models/Client/constants';

import {
  defaultPermissions,
  defaultRolePermissions as permissionsByRole,
  strictRolePermissions,
} from './constants';

export const createRoleConfigPayload = (roleId, isSuperAdmin) => {
  const permissions = { ...defaultPermissions };
  const defaultRolePermissions = permissionsByRole[isSuperAdmin ? roles.Admin.id : roleId];

  return Object.assign(permissions, {
    ...defaultRolePermissions,
    ...strictRolePermissions[roleId],
    patientChart: {
      quickSettings: {
        ...permissions.patientChart.quickSettings,
        ...defaultRolePermissions.patientChart.quickSettings,
      },
      actions: {
        ...permissions.patientChart.actions,
        ...defaultRolePermissions.patientChart.actions,
      },
      sections: {
        ...permissions.patientChart.sections,
        ...defaultRolePermissions.patientChart.sections,
        physicianOrders:
          defaultRolePermissions.patientChart.sections.physicianOrders === 'view-only'
            ? 'view-only'
            : {
                ...defaultRolePermissions.patientChart.sections.physicianOrders,
                assignedAsAC: roleId === roles.AccountabilityCoach.id,
                assignedAsRD: roleId === roles.RD.id,
              },
      },
    },
  });
};

export const isViewOnly = (permission) => permission === 'view-only';
